import React from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route, useLocation, useParams } from 'react-router-dom';
import { SettingsProvider } from './contexts/SettingsContext';
import ErrorBoundary from './ErrorBoundary';
import Login from './pages/Login';
import ErrorPage from './pages/ErrorPage';
import Callback from './pages/Callback';
import FilesPage from './pages/FilesPage';
import ProtectedRoute from './ProtectedRoute';
import PublicPage from './pages/PublicPage';

function LegacyFilesRedirect({ to = '/files' }) {
  const { fileId, userId, fileType, fileSubType, server } = useParams();
  const { search, hash } = useLocation();
  const params = new URLSearchParams(search);

  if (fileId) {
    params.delete('before');
    params.set('after', fileId);
  }
  if (fileType && fileSubType) params.set('type', fileType + '/' + fileSubType);

  let pathname = to;
  if (userId) pathname = '/users/' + encodeURIComponent(userId) + '/files';
  if (server) pathname = server === 'null' ? '/files' : '/servers/' + encodeURIComponent(server) + '/files';
  return <Navigate to={{ pathname, search: params.toString(), hash }} replace />;
}

function App() {
  return (
    <SettingsProvider>
      <ErrorBoundary>
        <Router>
          <Routes>
            <Route path="/" element={<PublicPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/callback" element={<Callback />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/files" element={<FilesPage />} />
              <Route path="/files/all" element={<FilesPage origin="combined" />} />
              <Route path="/files/remote" element={<FilesPage origin="remote" />} />
              <Route path="/users/:userId/files" element={<FilesPage origin="combined" />} />
              <Route path="/servers/:hostname/files" element={<FilesPage origin="remote" />} />
              <Route path="/home" element={<LegacyFilesRedirect />} />
              <Route path="/files/:fileId" element={<LegacyFilesRedirect />} />
              <Route path="/all/:fileId?" element={<LegacyFilesRedirect to="/files/all" />} />
              <Route path="/all/files/:fileId?" element={<LegacyFilesRedirect to="/files/all" />} />
              <Route path="/remote/:fileId?" element={<LegacyFilesRedirect to="/files/remote" />} />
              <Route path="/user/:userId/:fileId?" element={<LegacyFilesRedirect />} />
              <Route path="/server/:server/:fileId?" element={<LegacyFilesRedirect />} />
              <Route path="/type/:fileType/:fileSubType/:fileId?" element={<LegacyFilesRedirect />} />
              <Route path="/local/type/:fileType/:fileSubType/:fileId?" element={<LegacyFilesRedirect />} />
              <Route path="/combined/type/:fileType/:fileSubType/:fileId?" element={<LegacyFilesRedirect to="/files/all" />} />
              <Route path="/remote/type/:fileType/:fileSubType/:fileId?" element={<LegacyFilesRedirect to="/files/remote" />} />
            </Route>
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </Router>
      </ErrorBoundary>
    </SettingsProvider>
  );
}

export default App;
